import { render, staticRenderFns } from "./add-warranty.vue?vue&type=template&id=2d8f7043&scoped=true&"
import script from "./add-warranty.vue?vue&type=script&lang=js&"
export * from "./add-warranty.vue?vue&type=script&lang=js&"
import style0 from "./add-warranty.vue?vue&type=style&index=0&id=2d8f7043&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8f7043",
  null
  
)

export default component.exports